"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes_1 = require("./actionTypes");
function setThunktankLoading(tankSlice, thunkIndex) {
    return (dispatch) => {
        dispatch({
            type: actionTypes_1.THUNKTANK_LOADING,
            slice: tankSlice,
            thunkIndex
        });
    };
}
exports.default = setThunktankLoading;
